export default __webpack_public_path__ + "media/Playbtn1.ca6f4689.svg";